// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_UpdateDiscountResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/orders/update_discount/{id}
 *
 * Returns the order id, normalized discount config, and the recalculated
 * subtotal/total in cents.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_UpdateDiscountResponseDados {
order_id: number
discount_type: string
discount_value: number
subtotal: number
total: number
}

export type Orders_UpdateDiscountResponse = ApiResponse<Orders_UpdateDiscountResponseDados>;

registerResponseContract('Orders_UpdateDiscountResponse', {
  order_id:       { type: 'number',  required: true },
  discount_type:  { type: 'string',  required: true },
  discount_value: { type: 'number',  required: true },
  subtotal:       { type: 'number',  required: true },
  total:          { type: 'number',  required: true },
})
